'use client';

import type { EventBus } from '@hc-frontend/core-events';
import { createDomEventBus } from '@hc-frontend/core-events';
import { createContext, useContext, useMemo } from 'react';

export const CoreEventBus = createContext<EventBus>({
  publish: () => {},
  subscribe: () => () => {},
  unsubscribe: () => {},
});

export function useEventBus() {
  const eventBus = useContext(CoreEventBus);

  return eventBus;
}

export function DomEventBusProvider({
  children,
}: React.PropsWithChildren): JSX.Element {
  const eventBus = useMemo(createDomEventBus, []);
  return (
    <CoreEventBus.Provider value={eventBus}>{children}</CoreEventBus.Provider>
  );
}
